import React from "react";
import aboutImage from "../../assets/images/Founder-image/founder.jpeg";

const AboutSection = () => {
  const COLORS = {
    bgMain: "#0A0A0A",
    card: "rgba(255,255,255,0.04)",
    border: "rgba(255,255,255,0.08)",
    gold: "#D4AF37",
    text: "#EDEDED",
    subText: "#B0B0B0",
  };

  const services = [
    { id: "01", title: "Corporate Law", desc: "Strategic legal solutions for businesses and enterprises." },
    { id: "02", title: "Civil Litigation", desc: "Strong courtroom representation with proven expertise." },
    { id: "03", title: "Private Wealth", desc: "Protecting assets with precision and confidentiality." },
  ];

  return (
    <section
      className="py-16 md:py-24 px-4 md:px-10"
      style={{ background: COLORS.bgMain }}
    >
      <div className="max-w-7xl mx-auto">

        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* IMAGE SIDE */}
          <div className="relative group">
            <div className="overflow-hidden rounded-2xl">
              <img
                src={aboutImage}
                alt="Founder"
                className="w-full h-[500px] object-cover group-hover:scale-105 transition duration-700"
              />
            </div>

            {/* Glass Card */}
            <div
              className="absolute bottom-6 left-6 right-6 p-6 rounded-xl backdrop-blur-xl"
              style={{
                background: COLORS.card,
                border: `1px solid ${COLORS.border}`,
              }}
            >
              <h3 className="text-4xl font-bold" style={{ color: COLORS.gold }}>15+</h3>
              <p className="text-xs tracking-[0.3em] uppercase text-white mt-1">
                Years of Experience
              </p>
            </div>
          </div>

          {/* CONTENT SIDE */}
          <div>
            <p
              className="text-sm uppercase tracking-[0.4em] mb-4"
              style={{ color: COLORS.gold }}
            >
              About Advocate
            </p>

            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              Delivering Justice <br />
              <span className="text-white/60 font-light">With Precision & Integrity</span>
            </h2>

            <p className="text-lg leading-relaxed mb-8" style={{ color: COLORS.subText }}>
              Adv. Akash Giri provides high-quality legal representation with a
              strong commitment to ethics, transparency, and client success.
              Every case is handled with deep analysis and strategic execution.
            </p>

            {/* STATS */}
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="p-6 rounded-xl" style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                <h3 className="text-3xl font-bold text-white">500+</h3>
                <p className="text-sm mt-1" style={{ color: COLORS.subText }}>Cases Won</p>
              </div>
              <div className="p-6 rounded-xl" style={{ background: COLORS.card, border: `1px solid ${COLORS.border}` }}>
                <h3 className="text-3xl font-bold text-white">98%</h3>
                <p className="text-sm mt-1" style={{ color: COLORS.subText }}>Client Satisfaction</p>
              </div>
            </div>

            {/* SERVICES */}
            <div className="grid md:grid-cols-3 gap-4">
              {services.map((s) => (
                <div
                  key={s.id}
                  className="p-5 rounded-xl transition-all duration-300 hover:-translate-y-1"
                  style={{
                    background: COLORS.card,
                    border: `1px solid ${COLORS.border}`,
                  }}
                >
                  <span className="text-sm font-bold" style={{ color: COLORS.gold }}>
                    {s.id}
                  </span>
                  <h4 className="text-white font-semibold mt-2 mb-1 text-sm uppercase">
                    {s.title}
                  </h4>
                  <p className="text-xs" style={{ color: COLORS.subText }}>
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;